var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPipon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_304721",
    "data-name": "Group 304721",
    transform: "translate(-20 -618)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3151",
    "data-name": "Ellipse 3151",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(20 618)",
    fill: "#202124",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-picture-in-picture-5310492",
    transform: "translate(21.5 616.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_242389",
    "data-name": "Path 242389",
    d: "M31.5,16.25a1,1,0,0,1,1,1v7h-2v-6h-16v14h6v2h-7a1,1,0,0,1-1-1v-16a1,1,0,0,1,1-1Zm0,10a1,1,0,0,1,1,1v6a1,1,0,0,1-1,1h-8a1,1,0,0,1-1-1v-6a1,1,0,0,1,1-1Z",
    transform: "translate(0 0)",
    fill: "#85888a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipon);
export default __webpack_public_path__ + "static/media/PIPON.f9c5c648f1c2cb3a6fbfd68882f0c615.svg";
export { ForwardRef as ReactComponent };